import { render, staticRenderFns } from "./project_teachData.vue?vue&type=template&id=790668ec&scoped=true"
import script from "./project_teachData.vue?vue&type=script&lang=js"
export * from "./project_teachData.vue?vue&type=script&lang=js"
import style0 from "./project_teachData.vue?vue&type=style&index=0&id=790668ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790668ec",
  null
  
)

export default component.exports